import { useTranslate } from '@tolgee/react';
import { Tooltip } from 'antd';
import { ToolbarIcon } from '../ToolbarIcon';
import useIM from 'hooks/business/im/useIM';

interface LazadaFollowProps {
  conversation: Conversation.Conversation;
  onSend?: () => void;
}

export const LazadaFollow = (props: LazadaFollowProps) => {
  const {
    conversation: { conversationId },
    onSend,
  } = props;
  const { t } = useTranslate();
  const { sendFollower } = useIM();

  return (
    <Tooltip title={t('scene.chatWorkspace.messageEditor.action.inviteFollow')}>
      <ToolbarIcon
        icon="follow"
        onClick={() => {
          sendFollower(conversationId)
            .then(() => {
              onSend && onSend();
            })
            .catch(() => {});
        }}
      />
    </Tooltip>
  );
};
